import { SobLineChart } from 'legacy/lut/components/widgets/public/partner360/competitorsSob/components/sobLineChart/SobLineChart'
import {
  colors,
  hpColor,
  hpColorPlan,
} from 'legacy/lut/components/widgets/public/partner360/competitorsSob/configs'
import { ReactNode, useCallback } from 'react'

import {
  HP_COMPETITOR_ID,
  HP_COMPETITOR_PLAN_ID,
  OTHER_COMPETITOR_ID,
} from 'partner360/features/competitorsSob/constants'
import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

import { getOtherCompetitorSob } from './helpers/getOtherCompetitorSob'

import styles from './SobCompetitorsCharts.module.scss'

interface ISobCompetitorsChartsProps {
  visibleItems: ISobCompetitorsGroup[]
  chartLabelNode?: ReactNode
  selectedPeriodFYear: number
}

export const SobCompetitorsCharts = ({
  visibleItems,
  selectedPeriodFYear,
  chartLabelNode,
}: ISobCompetitorsChartsProps) => {
  const getLineSettings = useCallback((item: ISobCompetitorsGroup) => {
    return (
      item.Items.map((item, index, data) => {
        let lineType = 'solid'
        let color = colors[index]

        if (item.CompetitorID === OTHER_COMPETITOR_ID) {
          const getOtherValue = getOtherCompetitorSob(data)

          return {
            name: item.CompetitorName,
            lineType,
            color,
            data: [
              getOtherValue('PrevYearQ1ActualsSob'),
              getOtherValue('PrevYearQ2ActualsSob'),
              getOtherValue('PrevYearQ3ActualsSob'),
              getOtherValue('PrevYearQ4ActualsSob'),
              getOtherValue('CurrentYearQ1ActualsSob'),
              getOtherValue('CurrentYearQ2ActualsSob'),
              getOtherValue('CurrentYearQ3ActualsSob'),
              getOtherValue('CurrentYearQ4ActualsSob'),
            ],
          }
        }

        switch (item.CompetitorID) {
          case HP_COMPETITOR_ID:
            color = hpColor
            break

          case HP_COMPETITOR_PLAN_ID:
            color = hpColorPlan
            lineType = 'dashed'
            break

          default:
            break
        }

        return {
          name: item.CompetitorName,
          color,
          lineType,
          data: [
            item.PrevYearQ1ActualsSob,
            item.PrevYearQ2ActualsSob,
            item.PrevYearQ3ActualsSob,
            item.PrevYearQ4ActualsSob,
            item.CurrentYearQ1ActualsSob,
            item.CurrentYearQ2ActualsSob,
            item.CurrentYearQ3ActualsSob,
            item.CurrentYearQ4ActualsSob,
          ],
        }
      }) || []
    )
  }, [])

  return (
    <div className={styles.root}>
      {visibleItems.map((item) => {
        return (
          <div key={item.EntryId} className={styles.chart}>
            <SobLineChart
              selectedPeriodFYear={selectedPeriodFYear}
              chartLabelNode={chartLabelNode}
              chartName={item.Name}
              linesSettings={getLineSettings(item)}
              height={300}
            />
          </div>
        )
      })}
    </div>
  )
}
